import { useMutation, useQueryClient } from "@tanstack/react-query";
import { DataLake } from "@graylog/enterprise-api";
import UserNotification from "util/UserNotification";
const toggleStreamDataLakeConfigStatus = ({ streamIds, enabled }) => DataLake.toggleConfigEnableStatus({
  stream_ids: streamIds,
  enabled
});
const useStreamDataLakeStatusMutation = () => {
  const queryClient = useQueryClient();
  const { mutateAsync: onToggleStreamDataLakeConfigStatus } = useMutation({
    mutationFn: toggleStreamDataLakeConfigStatus,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["data-lake-config"]
      });
    },
    onError: (errorThrown) => {
      UserNotification.error(
        `Toggling Data Lake config status failed with status: ${errorThrown}`,
        "Toggling Data Lake config status"
      );
    }
  });
  return { onToggleStreamDataLakeConfigStatus };
};
export default useStreamDataLakeStatusMutation;
